import { createAction } from 'redux-actions';
import { setLabels, setLabelsRemote } from './constants';

export const updateTranslations: any = createAction(setLabels, (language: string) => language);
export const updateTranslationsRemote: any = createAction(setLabelsRemote, (labels: types.redux.dynamicLabels.State) => labels);

